var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"com-label"},[_vm._v("组件写法"),_c('i',{staticClass:"el-icon-star-on star",style:({ color: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }